var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleDrive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 800,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0F0F0F",
    fillRule: "evenodd",
    d: "M8.574 2a2 2 0 0 0-1.727.992L.45 13.957a2 2 0 0 0 .063 2.117l3.357 5.035A2 2 0 0 0 5.535 22h12.93a2 2 0 0 0 1.664-.89l3.357-5.036a2 2 0 0 0 .063-2.117L17.153 2.992A2 2 0 0 0 15.426 2H8.574Zm1.23 2h5.622l5.833 10h-5.205L9.804 4Zm3.892 10-1.787-2.86L10.24 14h3.455Zm-4.622 2-2.333 4h11.724l2.666-4H9.074Zm1.637-6.775-5.768 9.887-2.765-4.147L8.03 4.934l2.681 4.29Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleDrive);
export default __webpack_public_path__ + "static/media/google-drive.2de0fb24c0eb7205d2b42c740c41b0a2.svg";
export { ForwardRef as ReactComponent };